<div class="box">
    <div  *ngIf="dashboardInfo">
    <div class="box-header">
        <app-date-component-renderer [isKpiSalesGraph]="false" [position]="page == 'productDetailPanel' ? false : true" [page]="page" [currentDateFilter]="dateInfo[0]" [isKpiDashboardId]="id"></app-date-component-renderer>
        <ul class="box-header_tabs">
            <li class="box-header_tabs--items">
                <button class="tab-btn" [ngClass]="{'active': !showGraph}" (click)="showChart(false)">
                    <svg width="12.45" height="12.45"><use xlink:href="assets/images/sprite-icons.svg#table-split"></use></svg>
                </button>
            </li>
            <li class="box-header_tabs--items">
                <button class="tab-btn" [ngClass]="{'active': showGraph}" (click)="showChart(true)">
                    <svg width="14.21" height="14.21"><use xlink:href="assets/images/sprite-icons.svg#pie-chart"></use></svg>
                </button>
            </li>
        </ul> 
    </div>
    <div *ngIf="!showGraph">
        <div class="box-container">
            <div class="box-container_item">
                <div class="box-container_item--header">
                    Sales
                </div>
                <ul class="box-container_item--list">
                    <li>
                        <label>Revenue</label>
                        <p><span class="value">{{dashboardInfo.revenue | currency }}</span><span class="dropdown-icon"><i class="fa fa-chevron-down"  (click)="openDialog($event,'Revenue')"></i></span></p>
                    </li>
                    <li>
                        <label>Refund</label>
                        <p><span class="value">{{dashboardInfo.refund | currency}}</span> <span class="dropdown-icon"><i class="fa fa-chevron-down"  (click)="openDialog($event,'Refund')" ></i></span></p>
                    </li>
                    <li>
                        <label>Orders</label>
                        <p><span class="value">{{dashboardInfo.orders}}</span><span class="dropdown-icon"><i class="fa fa-chevron-down" (click)="openDialog($event,'Orders')"></i></span></p>
                    </li>
                </ul>
            </div>
            <div class="box-container_item">
                <div class="box-container_item--header">
                    Fees
                </div>
                <ul class="box-container_item--list">
                    <li>
                        <label>Sales Fees</label>
                        <p><span class="value">{{dashboardInfo.salesFees | currency}}</span><span class="dropdown-icon"><i class="fa fa-chevron-down" (click)="openDialog($event,'Sales Fees')" ></i></span></p>
                    </li>
                    <li>
                        <label>Other Fees</label>
                        <p><span class="value">{{dashboardInfo.otherFees | currency}}</span><span class="dropdown-icon"><i class="fa fa-chevron-down" (click)="openDialog($event,'Other Fees')" ></i></span></p>
                    </li>
                </ul>
            </div>
            <div class="box-container_item">
                <div class="box-container_item--header">
                    COGS
                </div>
                <ul class="box-container_item--list">
                    <li>
                        <label>Sales COGS</label>
                        <p><span class="value">{{dashboardInfo.salesCogs | currency}}</span><span class="dropdown-icon"><i class="fa fa-chevron-down" (click)="openDialog($event,'Sales COGS')"></i></span></p>
                    </li>
                    <li>
                        <label>Return COGS</label>
                        <p><span class="value">{{dashboardInfo.returnCogs | currency}}</span></p>
                    </li>
                </ul>
            </div>
            <div class="box-container_item">
                <div class="box-container_item--header">
                    PPC
                </div>
                <ul class="box-container_item--list">
                    <li>
                        <label>Spent</label>
                        <p><span class="value">{{dashboardInfo.ppcSpent | currency}}</span></p>
                    </li>
                    <li>
                        <label>ACOS</label>
                        <p><span class="value">{{dashboardInfo.ppcAcos / 100 | percent:'1.2-2' }}</span></p>
                    </li>
                    <li>
                        <label>TACOS</label>
                        <p><span class="value">{{dashboardInfo.ppcTacos / 100 | percent:'1.2-2'}}</span></p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="box-result">
            <div class="box-result_left">
                Total Profit
                <p class="box-result_left--amount">
                    {{dashboardInfo.profit | currency}}
                    <span class="analytics-badge"  (click)="openDialog($event,'Profit')">
                        <svg class="me-1" width="6.34" height="6.34"><use xlink:href="assets/images/sprite-icons.svg#bar-chart"></use></svg>
                        P&L
                    </span>
                </p>
            </div>
            <ul class="box-container_item--list p-0">
                <li class="d-flex mb-0">
                    <label>Margin</label>
                    <p class="ms-2">{{dashboardInfo.margin}}%</p>
                </li>
                <li class="d-flex mb-0">
                    <label>Markup</label>
                    <p class="ms-2">{{dashboardInfo.markup}}%</p>
                </li>
            </ul>
        </div>
    </div>
    <div class="box-graph" *ngIf="showGraph">
        <app-sales-trends-graph [chartDataSet]="dashboardInfo" [id]="id"></app-sales-trends-graph>
        <div class="box-graph_detail">
            <div class="box-graph_detail--item">
                <label>Revenue</label>
                <p><span class="value">{{dashboardInfo.revenue | currency}}</span> <span class="dropdown-icon"><i class="fa fa-chevron-down" (click)="openDialog($event,'Revenue')"></i></span></p>
            </div>
                <div class="box-graph_detail--item">
                    <label>Refund</label>
                    <p><span class="value">{{dashboardInfo.refund | currency}}</span><span class="dropdown-icon"><i class="fa fa-chevron-down" (click)="openDialog($event,'Refund')"></i></span></p>
                </div>
                <div class="box-graph_detail--item">
                    <label>Orders</label>
                    <p><span class="value">{{dashboardInfo.orders}}</span><span class="dropdown-icon"><i class="fa fa-chevron-down" (click)="openDialog($event,'Orders')"></i></span></p>
            </div>
            <span class="analytics-badge" (click)="openDialog($event,'Profit')" [ngClass]="{'disabled' : showDisable}" >
                <svg class="me-1" width="6.34" height="6.34"><use xlink:href="assets/images/sprite-icons.svg#bar-chart"></use></svg>
                P&L
            </span>
        </div>
    </div>
    </div>
    <div class="loader" *ngIf="!dashboardInfo">
        <img [src]="'assets/images/nineyard-loading.gif'" />
    </div>   
</div>